import React from 'react';

const Input = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  error,
  touched,
  placeholder,
  required = false,
  disabled = false,
  hint,
  icon: Icon,
  suffix,
  className = '',
  ...props
}) => {
  const hasError = error && touched;

  const inputClasses = [
    'w-full rounded-lg border bg-white text-sm text-ink-900 placeholder-ink-400',
    'transition-shadow duration-150',
    'focus:outline-none focus:ring-4',
    Icon ? 'pl-10' : 'pl-3.5',
    suffix ? 'pr-12' : 'pr-3.5',
    'py-2.5',
    hasError
      ? 'border-rose-400 focus:border-rose-500 focus:ring-rose-100'
      : 'border-ink-200 hover:border-ink-300 focus:border-brand-500 focus:ring-brand-100',
    disabled ? 'bg-ink-50 text-ink-500 cursor-not-allowed' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="space-y-1.5">
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-ink-700"
        >
          {label}
          {required && <span className="text-rose-500 ml-0.5">*</span>}
        </label>
      )}

      <div className="relative">
        {Icon && (
          <Icon className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-400" />
        )}
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={inputClasses}
          {...props}
        />
        {suffix && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center">
            {suffix}
          </div>
        )}
      </div>

      {hasError ? (
        <p className="text-xs text-rose-600">{error}</p>
      ) : hint ? (
        <p className="text-xs text-ink-500">{hint}</p>
      ) : null}
    </div>
  );
};

export default Input;
